enum EmitOptions {
	CLOSE_MODAL = 'closeModal'
}

export { EmitOptions };
